(() => {
  if (window.hpmQuantitySummaryReady) return;
  window.hpmQuantitySummaryReady = true;

  let cartItems = [];
  const cards = () => document.querySelectorAll('.hpm-quantity-summary');

  function formatMoney(cents, currency) {
    const code = currency || 'HKD';
    try {
      return new Intl.NumberFormat('en-HK', {
        style: 'currency', currency: code,
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (error) {
      return `${code} ${(cents / 100).toFixed(2)}`;
    }
  }

  function offerFor(card, quantity) {
    if (Date.now() > Date.parse(card.dataset.offerEndsAt || '')) return null;
    const type = card.dataset.offerType;
    if (type === 'royal') return { percent: 10, label: '已計入 Royal Canin 9 折' };

    if (type === 'orijen') {
      const otherCount = cartItems.reduce((sum, item) =>
        sum + (String(item.vendor).toLowerCase() === 'orijen' ? Number(item.quantity) || 0 : 0), 0);
      return quantity + otherCount >= 2
        ? { percent: 5, label: '已計入 Orijen 2 件 95 折' } : null;
    }

    if (type === 'ciao') {
      const eligible = (vendor) => ['ciao', 'inaba', 'inaba-〈ciao〉'].includes(String(vendor).toLowerCase());
      const otherSubtotal = cartItems.reduce((sum, item) => sum + (eligible(item.vendor)
        ? Number(item.original_line_price ?? (item.price * item.quantity)) || 0 : 0), 0);
      const price = Number(card.hpmSelectedPrice) || 0;
      return price * quantity + otherSubtotal >= 18800
        ? { percent: 10, label: '已計入 CIAO＋INABA 滿 HK$188 9 折' } : null;
    }
    if (type === 'hills') {
      const eligibleIds = card.dataset.hillsProductIds || '';
      const otherCount = cartItems.reduce((sum, item) =>
        sum + (eligibleIds.includes(`|${item.product_id}|`) ? Number(item.quantity) || 0 : 0), 0);
      return quantity + otherCount >= 12
        ? { percent: 10, label: '已計入 Hill’s 罐頭 12 件 9 折' } : null;
    }
    return null;
  }

  function priceFor(card, unitPrice, quantity) {
    const offer = offerFor(card, quantity);
    const total = Math.round(unitPrice * quantity * (offer ? 100 - offer.percent : 100) / 100);
    return { offer, total, saving: unitPrice * quantity - total };
  }

  function updateChoices(card, input, variant, quantity) {
    const choices = card.querySelector('[data-hpm-choices]');
    if (!choices) return;
    const minimum = Number.parseInt(input.min || '1', 10) || 1;
    const maximum = Number.parseInt(input.max, 10);
    const increment = Number.parseInt(input.step || '1', 10) || 1;
    let shown = 0;

    choices.querySelectorAll('[data-hpm-choice-qty]').forEach((button) => {
      const count = Number.parseInt(button.dataset.hpmChoiceQty, 10);
      const valid = count >= minimum && (!Number.isFinite(maximum) || count <= maximum)
        && (count - minimum) % increment === 0;
      button.hidden = !valid;
      if (!valid) return;
      shown += 1;
      const price = priceFor(card, Number(variant.price), count);
      button.setAttribute('aria-pressed', String(quantity === count));
      button.querySelector('[data-hpm-choice-total]').textContent = formatMoney(price.total, card.dataset.currency);
      button.querySelector('[data-hpm-choice-average]').textContent = `平均 ${formatMoney(price.total / count, card.dataset.currency)}／件`;
      const saving = button.querySelector('[data-hpm-choice-save]');
      saving.hidden = price.saving <= 0;
      saving.textContent = price.saving > 0 ? `節省 ${formatMoney(price.saving, card.dataset.currency)}` : '';
    });
    choices.hidden = !variant.available || shown < 2
      || Date.now() > Date.parse(card.dataset.offerEndsAt || '');
  }

  function update(card) {
    const sectionId = card.dataset.sectionId;
    const quantityInput = document.getElementById(`Quantity-${sectionId}`);
    const form = document.getElementById(`product-form-${sectionId}`);
    const variantInput = form && form.querySelector('input[name="id"]');
    if (!quantityInput || !variantInput) return;

    if (!card.hpmVariants) {
      try {
        card.hpmVariants = JSON.parse(card.querySelector('.hpm-quantity-summary__variants').textContent);
      } catch (error) {
        return;
      }
    }
    const variantId = variantInput.value || card.dataset.selectedVariantId;
    const variant = card.hpmVariants.find((item) => String(item.id) === String(variantId));
    if (!variant || !Number.isFinite(Number(variant.price))) {
      card.hidden = true;
      return;
    }

    const entered = Number.parseInt(quantityInput.value, 10);
    const minimum = Number.parseInt(quantityInput.min || quantityInput.dataset.min || '1', 10);
    const quantity = Number.isFinite(entered) && entered > 0 ? entered : (minimum || 1);
    const price = Number(variant.price);
    card.hpmSelectedPrice = price;
    const calculation = priceFor(card, price, quantity);
    const offer = calculation.offer;
    const total = calculation.total;
    const note = card.querySelector('[data-hpm-offer-note]');

    card.hidden = !variant.available;
    card.querySelector('[data-hpm-quantity]').textContent = String(quantity);
    card.querySelector('[data-hpm-total]').textContent = formatMoney(total, card.dataset.currency);
    card.querySelector('[data-hpm-average]').textContent = formatMoney(total / quantity, card.dataset.currency);
    note.hidden = !offer;
    note.textContent = offer ? `${offer.label}；迎新碼於結帳確認` : '';
    updateChoices(card, quantityInput, variant, quantity);
  }

  function updateAll() { cards().forEach(update); }

  async function refreshCart() {
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) return;
      const cart = await response.json();
      cartItems = Array.isArray(cart.items) ? cart.items : [];
      updateAll();
    } catch (error) {
      // Selected-quantity estimates remain available if the cart cannot be read.
    }
  }

  function start() { updateAll(); refreshCart(); }
  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('input', (event) => {
    if (event.target.matches('.quantity__input')) updateAll();
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('.quantity__input, .product-variant-id')) updateAll();
  });
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('[data-hpm-choice-qty]');
    if (choice && !choice.hidden) {
      const card = choice.closest('.hpm-quantity-summary');
      const input = card && document.getElementById(`Quantity-${card.dataset.sectionId}`);
      if (input) {
        input.value = choice.dataset.hpmChoiceQty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        update(card);
      }
      return;
    }
    if (event.target.closest('.quantity__button')) requestAnimationFrame(updateAll);
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshCart();
  });
  if (document.readyState !== 'loading') start();
})();
